export function WidgetTypingIndicator() {
    return (
        <div className="op-row op-group-start">
            <div className="op-bubble-wrap">
                <div
                    className="op-bubble op-pos-solo op-bubble-in op-typing"
                    role="status"
                    aria-label="Typing"
                >
                    <span className="op-typing-dot" aria-hidden="true" />
                    <span className="op-typing-dot" aria-hidden="true" />
                    <span className="op-typing-dot" aria-hidden="true" />
                </div>
            </div>
        </div>
    );
}
